import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AutoCompleteModule } from 'primeng/autocomplete';
import { DataViewModule } from 'primeng/dataview';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';

import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { HisCoreSharedModule } from '../core/his-core-shared.module';
import { HisStructureSharedModule } from '../structure/his-structure-shared.module';
import { HisMultiselectPlamComponent } from './component/multiselect/his-multiselect-plam.component';
import { HisMultiselectComponent } from './component/multiselect/his-multiselect.component';
import { HisMultiselectAutocompleteComponent } from './component/multiselect/subComponent/his-multiselect-autocomplete.component';
import { HisMultiselectAutocompleteAccessibilityDirective } from './component/multiselect/subComponent/his-multiselect-autocomplete.directive';
import { HisMultiselectSelectedOptionsListComponent } from './component/multiselect/subComponent/his-multiselect-selected-options-list.component';
import { HisMultiselectSelectionDialogComponent } from './component/multiselect/subComponent/his-multiselect-selection-dialog.component';
import { HisCodeEditorComponent } from './his-code-editor/his-code-editor.component';
/**
 * SharedModule with generic search components (and eventually directives and pipes) to import in child
 * modules of HIS Angular applications. Import HisCoreModule in the root module.
 */
@NgModule( {
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,

        // primeng
        TableModule,
        DataViewModule,
        DialogModule,
        AutoCompleteModule,
        ProgressSpinnerModule,

        // HIS
        HisCoreSharedModule,
        HisStructureSharedModule,
        HisCodeEditorComponent,
        HisMultiselectAutocompleteAccessibilityDirective
    ],

    declarations: [
        HisMultiselectAutocompleteComponent,
        HisMultiselectPlamComponent,
        HisMultiselectSelectedOptionsListComponent,
        HisMultiselectSelectionDialogComponent,
        HisMultiselectComponent,        
    ],

    exports: [
        HisMultiselectAutocompleteComponent,
        HisMultiselectPlamComponent,
        HisMultiselectSelectedOptionsListComponent,
        HisMultiselectSelectionDialogComponent,
        HisMultiselectComponent,
        HisCodeEditorComponent
    ]
    // NO PROVIDERS! Providers need to go into HisInputCoreModule
} )
export class HisInputSharedModule {

}
